import { useState } from "react";
import { Text } from "@ttc3k/trekker";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { ActionCard, CollapsableStep } from "widgets/booker/shared";
import { PoliciesPage } from "widgets/booker/features/OverlayPages";
import { AssetFile } from "gql/generated";
import { useTranslation } from "react-i18next";

export const Policies = () => {
  const { acceptPolicies, acceptedPolicies } = useCartContext();
  const { booker } = useBookerContext();

  const { t } = useTranslation("booker", { keyPrefix: "POLICIES" });

  const [isPoliciesPageOpen, setIsPoliciesPageOpen] = useState(false);
  return (
    <CollapsableStep
      title={t("TITLE")}
      complete={acceptedPolicies}
      stepId="policies"
    >
      <Text color="text.mid">{t("SUBTITLE")}</Text>
      <ActionCard
        mainText={t("TITLE")}
        subText={acceptedPolicies ? t("ACCEPTED") : t("REQUIRED")}
        visual={acceptedPolicies ? "success" : "neutral"}
        isEditable={false}
        onClick={() => setIsPoliciesPageOpen(true)}
      />
      <PoliciesPage
        open={isPoliciesPageOpen}
        onClose={() => setIsPoliciesPageOpen(false)}
        acceptedPolicies={acceptedPolicies}
        acceptPolicies={acceptPolicies}
        policies={booker?.policies}
        waivers={booker?.waivers as AssetFile[] | undefined}
      />
    </CollapsableStep>
  );
};
